/* Original name @uswitch/trustyle.circular-percentage-bar */
import React from 'react';
import { CircularPercentageBarStyles } from './percentage-bar-styles';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var styles = function styles(element) {
  return "elements.circle-percentage-bar.base".concat(element ? ".".concat(element) : '');
};

var alignCircle = function alignCircle(side) {
  return side !== 'center' ? "flex-".concat(side) : 'center';
};

var drawCircle = function drawCircle(pct) {
  var isBackground = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var cls = isBackground ? '-full' : '';
  var deg = 360 / 100 * pct;
  return _jsxs("div", {
    className: "slice".concat(cls),
    children: [_jsx("div", {
      className: "bar".concat(cls),
      sx: {
        transform: "rotate(".concat(deg, "deg)"),
        variant: styles("bar".concat(cls))
      }
    }), _jsx("div", {
      className: "fill".concat(cls),
      sx: {
        variant: isBackground ? styles("fill".concat(cls)) : deg > 180 ? styles('fill') : ''
      }
    })]
  });
};

var CircularPercentageBar = function CircularPercentageBar(_ref) {
  var percentage = _ref.percentage,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'xs' : _ref$size,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align;
  return _jsx("div", {
    css: CircularPercentageBarStyles,
    sx: {
      display: 'flex',
      justifyContent: Array.isArray(align) ? align.map(function (a) {
        return alignCircle(a);
      }) : alignCircle(align)
    },
    children: _jsxs("div", {
      className: "c100 ".concat(size, " ").concat(percentage > 50 ? 'gt50' : ''),
      sx: {
        variant: styles()
      },
      children: [_jsxs("span", {
        sx: {
          variant: styles('text')
        },
        children: [percentage, "%"]
      }), drawCircle(100, true), drawCircle(percentage)]
    })
  });
};

export default CircularPercentageBar;
//# sourceMappingURL=index.js.map